module.exports = __webpack_public_path__ + "adea35bc6462d1696e8305cf3221f0cd.png";